export var SelectionMode;
(function (SelectionMode) {
    SelectionMode[SelectionMode["Single"] = 1] = "Single";
    SelectionMode[SelectionMode["Multiple"] = 2] = "Multiple";
})(SelectionMode || (SelectionMode = {}));
